require("!!/builds/lobaro/iot-dashboard/node_modules/mocha-loader/web.js");
mocha.setup("bdd");
require("!!/builds/lobaro/iot-dashboard/node_modules/ts-loader/index.js!/builds/lobaro/iot-dashboard/src/browser-tests.ts")
require("!!/builds/lobaro/iot-dashboard/node_modules/mocha-loader/start.js");
if(module.hot) {
	module.hot.accept();
	module.hot.dispose(function() {
		mocha.suite.suites.length = 0;
		var stats = document.getElementById('mocha-stats');
		var report = document.getElementById('mocha-report');
		stats.parentNode.removeChild(stats);
		report.parentNode.removeChild(report);
	});
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/mocha-loader!./src/browser-tests.ts
 ** module id = 109
 ** module chunks = 1
 **/